var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99911 18C5.34221 18 3.99911 16.6569 3.99911 15C3.99911 13.3431 5.34221 12 6.99911 12C8.65601 12 9.99911 13.3431 9.99911 15C9.99911 16.6569 8.65601 18 6.99911 18ZM19.9991 15C19.9991 13.3431 18.656 12 16.9991 12C15.3422 12 13.9991 13.3431 13.9991 15C13.9991 16.6569 15.3422 18 16.9991 18C18.656 18 19.9991 16.6569 19.9991 15ZM2.20991 20.7154C1.99541 21.3482 2.50381 22 3.17191 22H10.8263C11.4944 22 12.0028 21.3481 11.7883 20.7154C11.2532 19.1364 9.75891 18 7.99911 18H5.99911C4.23931 18 2.74491 19.1364 2.20991 20.7154ZM21.7884 20.7154C21.2533 19.1364 19.759 18 17.9992 18H15.9992C14.2394 18 12.745 19.1364 12.21 20.7154C11.9955 21.3482 12.5039 22 13.172 22H20.8264C21.4945 22 22.0029 21.3481 21.7884 20.7154ZM14.9991 5C14.9991 3.3431 13.656 2 11.9991 2C10.3422 2 8.99911 3.3431 8.99911 5C8.99911 6.6569 10.3422 8 11.9991 8C13.656 8 14.9991 6.6569 14.9991 5ZM7.52501 10.0532C8.61661 10.1694 9.60031 10.6307 10.3659 11.3324C10.8163 11.7453 11.3879 12.0001 11.999 12.0001C12.6101 12.0001 13.1817 11.7453 13.6321 11.3324C14.3977 10.6307 15.3814 10.1694 16.473 10.0532C15.7878 8.8337 14.4974 8 12.9989 8H10.9989C9.50051 8 8.21031 8.8337 7.52501 10.0532Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/users-group.6573e563af7a2761d85b688fd0dce396.svg";
export { ForwardRef as ReactComponent };